import { ACTION_TYPES } from "constants/action-types";

export function toggleVacationMode() {
  return (dispatch, getState) => {
    const currentState = getState().settings.isVacationModeOpen;
    dispatch({
      type: ACTION_TYPES.SETTINGS.TOGGLE_VACATION_MODE,
      payload: !currentState,
    });
  };
}

export function setVacationStatus(payload) {
  return {
    type: ACTION_TYPES.SETTINGS.SET_VACATION_STATUS,
    payload
  };
}

export function setActiveVacation(payload) {
  return {
    type: ACTION_TYPES.SETTINGS.SET_ACTIVE_VACATION,
    payload
  };
}

export function setFutureVacations(payload) {
  return {
    type: ACTION_TYPES.SETTINGS.SET_FUTURE_VACATIONS,
    payload
  };
}

export function setVacationDetails(payload) {
  return {
    type: ACTION_TYPES.SETTINGS.SET_VACATION_DETAILS,
    payload
  };
}

export function setShowBackInAction(payload) {
  return {
    type: ACTION_TYPES.SETTINGS.SET_SHOW_BACK_IN_ACTION,
    payload
  };
}

export function setVacationToUpdate(payload) {
  return {
    type: ACTION_TYPES.SETTINGS.SET_VACATION_TO_UPDATE,
    payload
  };
}

export function setReactivateModalOpen () {
  return {
    type: ACTION_TYPES.SETTINGS.SET_REACTIVATE_MODAL_OPEN
  }
};

export function setReactivateModalClosed () {
  return {
    type: ACTION_TYPES.SETTINGS.SET_REACTIVATE_MODAL_CLOSED
  }
};